import { css } from '@emotion/react';
import { baseButtonStyles } from '../../style.js';

var linkButtonStyles = _ref => {
  var {
    buttonColor,
    buttonType,
    disabled,
    isFullWidth = false,
    isLoading = false,
    textColor,
    theme
  } = _ref;
  return /*#__PURE__*/css(baseButtonStyles({
    buttonColor,
    buttonType,
    disabled,
    isFullWidth,
    isLoading,
    textColor,
    theme
  }), " ", disabled ? "\n  span {\n    color: ".concat(theme.COLORS.textDisabled, ";\n  }\n  ") : '', ";;label:linkButtonStyles;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVtSSIsImZpbGUiOiJzdHlsZS50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IGJhc2VCdXR0b25TdHlsZXMgfSBmcm9tICcuLi8uLi9zdHlsZSc7XG5jb25zdCBsaW5rQnV0dG9uU3R5bGVzID0gKHsgYnV0dG9uQ29sb3IsIGJ1dHRvblR5cGUsIGRpc2FibGVkLCBpc0Z1bGxXaWR0aCA9IGZhbHNlLCBpc0xvYWRpbmcgPSBmYWxzZSwgdGV4dENvbG9yLCB0aGVtZSwgfSkgPT4gY3NzIGBcbiAgJHtiYXNlQnV0dG9uU3R5bGVzKHtcbiAgICBidXR0b25Db2xvcixcbiAgICBidXR0b25UeXBlLFxuICAgIGRpc2FibGVkLFxuICAgIGlzRnVsbFdpZHRoLFxuICAgIGlzTG9hZGluZyxcbiAgICB0ZXh0Q29sb3IsXG4gICAgdGhlbWUsXG59KX1cblxuICAke2Rpc2FibGVkXG4gICAgPyBgXG4gIHNwYW4ge1xuICAgIGNvbG9yOiAke3RoZW1lLkNPTE9SUy50ZXh0RGlzYWJsZWR9O1xuICB9XG4gIGBcbiAgICA6ICcnfVxuYDtcbmV4cG9ydCBkZWZhdWx0IHtcbiAgICBsaW5rQnV0dG9uU3R5bGVzLFxufTtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPXN0eWxlLmpzLm1hcCJdfQ== */"));
};

var Style = {
  linkButtonStyles
};

export { Style as default };
